/* eslint-disable react/prop-types */
import React from 'react';
import numeral from 'numeral';
import { map } from 'lodash';
import { Link } from 'react-router-dom';

export const formatNetworks = ({ data = [], fields = {} } = {}) =>
  map(data, network => ({
    network: network[fields.network],
    networkId: network[fields.networkId],
    viewshare: network[fields.viewshare],
    viewershare: network[fields.viewershare]
  }));

export const defaultSorts = ['viewshare'];

export const columns = [
  {
    Header: '',
    accessor: (row, i) => i + 1,
    id: 'index',
    className: 'tvt-tabular-data-table__rank'
  },
  {
    Header: 'Network',
    accessor: 'network',
    className: 'tvt-tabular-data-table__network-ranker-network',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/network/${original.networkId}`}>{value}</Link>
    )
  },
  {
    Header: 'Share of Views',
    accessor: 'viewshare',
    Cell: ({ cell: { value } }) => `${numeral(value).format('0.00')}%`,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__network-ranker-view-share',
    sortDescFirst: true,
    hoverTitle:
      'The portion of all Views, for selected filter criteria, belonging to a specific piece of content'
  },
  {
    Header: 'Share of Viewers',
    accessor: 'viewershare',
    Cell: ({ cell: { value } }) => `${numeral(value).format('0.00')}%`,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__network-ranker-viewer-share',
    sortDescFirst: true,
    hoverTitle:
      'Share of Viewers measures how many people are in an audience (those who view a specific piece of content) compared to the total audience of the app. It is important to note that the users are not mutually exclusive in this calculation, and therefore the sum can total greater than 100%'
  }
];

export default { columns, formatNetworks, defaultSorts };
